import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	more: {
		id: 'admin-pages-priorities.priorities-table.actions.more',
		defaultMessage: 'Move priority {priorityName}',
		description:
			'Label text for dropdown trigger button to display additional options, displayed in priority table',
	},
	edit: {
		id: 'admin-pages-priorities.priorities-table.actions.edit',
		defaultMessage: 'Edit priority {priorityName}',
		description: 'Label text for button to edit a priority, displayed in priority table',
	},
	delete: {
		id: 'admin-pages-priorities.priorities-table.actions.delete',
		defaultMessage: 'Delete priority {priorityName}',
		description: 'Label text for button to delete a priority, disabled in priority table',
	},
});
